import React from "react";
import styles from './Middle.module.css';
import logo1 from '../../../assets/aboutUs/middle1.png';
import logo2 from '../../../assets/aboutUs/middle2.png';
import logo3 from '../../../assets/aboutUs/middle3.png';

const Middle = () =>{
    return(
        <div style={{backgroundColor: '#f8f8f8'}} className='overflow-hidden'>
            <div className={`container ${styles.contain}`}>
                <p data-aos='fade-down-right' data-aos-offset="170" className={styles.mainHead}>Pain itself is loved.</p>
                <p data-aos='fade-up-left' data-aos-offset="170" className={styles.mainContent}>Al Rimal Finance Consultancy and Digital Solutions is a trusted partner for businesses seeking innovative financial expertise and digital transformation. With our headquarters in Abu Dhabi and an expanding presence across the UAE, we have quickly gained recognition since our inception for bringing clarity and confidence to our clients’ financial operations.

Our team is made up of seasoned professionals who are passionate about delivering excellence in accounting, audit, financial advisory, VAT and corporate tax consulting, and digital business solutions. With extensive local and international experience, the Al Rimal team understands the evolving economic and regulatory landscape of the UAE and beyond, which enables us to deliver tailored, forward-thinking solutions for each client.

We are committed to the highest levels of professionalism, ethical standards, and integrity in everything we do. Our advisors keep pace with the latest developments in compliance, technology, and industry best practices to ensure our clients receive strategic, up-to-date advice that empowers sustainable business growth.

Whether you are a startup, an established business, or seeking to expand internationally, Al Rimal Finance Consultancy and Digital Solutions is dedicated to supporting your journey through trusted expertise, personalized service, and smart digital tools for a new era of business.</p>

                <div className="row">
                    <div data-aos='fade-right' data-aos-offset="170" className="col-md-4">
                        <div className={styles.box}>
                            <img src={logo1} alt=""/>
                            <p className={styles.head}>Global Presence</p>
                            <p className={styles.content}>Chartered Accountants with strong presence in India, UAE, Canada & Netherlands
</p>
                        </div>
                    </div>

                    <div data-aos='fade-up' className="col-md-4">
                        <div className={styles.box}>
                            <img src={logo2} alt=""/>
                            <p className={styles.head}>Experienced Leadership</p>
                            <p className={styles.content}>72+ years of combined leadership experience guiding strategic financial solutions</p>
                        </div>
                    </div>

                   

                    <div data-aos='fade-left' className="col-md-4">
                        <div className={styles.box}>
                            <img src={logo3} alt=""/>
                            <p className={styles.head}>Core Values</p>
                            <p className={styles.content}>Focused on accuracy, compliance, and timely delivery across all engagements</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
export default Middle;